import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="hidden sm:block">
      <ol className="flex items-center gap-1 text-sm">
        <li>
          <span className="flex items-center gap-1 font-semibold text-slate-500 dark:text-slate-400">
            <Home className="h-4 w-4" aria-hidden="true" />
            Portal
          </span>
        </li>
        {items.map((item) => (
          <li key={item} className="flex items-center gap-1">
            <ChevronRight className="h-4 w-4 text-slate-400" aria-hidden="true" />
            <span className="font-bold text-slate-800 dark:text-slate-100">{item}</span>
          </li>
        ))}
      </ol>
    </nav>
  );
}
